import $ from 'jquery';

let $window = $(window);
let $document = $(document);
let $html = $('html');
let $header = $('[id="header"]');
let $headerNav = $('.header-nav');

// Scroll
$(function () {
    let headerTop = $header.offset().top;
    let headerNavTop = $headerNav.offset().top;

    $window.on('scroll resize load', function () {
        let scroll = $window.scrollTop();
        let position = parseInt($window.scrollTop() + $window.height());
        let minPosition = parseInt($document.height() - 300);

        $html.toggleClass('-fixed-header', scroll > headerTop);
        $html.toggleClass('-fixed-header-nav', scroll > headerNavTop);
        $html.toggleClass('-page-is-scrolled-down', scroll > 0);
        $html.toggleClass('-should-show-scroll-up', scroll > 200 && position > minPosition);
    });
});

// Header note
if ($('.header-note').length) {
    $html.addClass('-has-header-note');
}

// Loading class
$document.ajaxStart(() => {
    $html.addClass('-has-xhr-activity');
}).ajaxComplete(() => {
    $html.removeClass('-has-xhr-activity');
});



// WEBPACK FOOTER //
// ./assets/app/js/layout/index.js